import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { MediaCenterServiceProxy, GetMediaCenterForViewDto, MediaLibraryServiceProxy } from '@shared/service-proxies/service-proxies';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient } from '@angular/common/http';

@Component({
    templateUrl: './media-center-detail.component.html',
    animations: [appModuleAnimation()],
    styles: [`
        .video-preloader-wrapper {
            position: relative;
        }
        .video-preloader-skeleton {
            position: relative;
            width: 100%;
            height: 360px;
            background: #1a1a2e;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .video-preloader-shimmer {
            position: absolute;
            top: 0;
            left: -100%;
            width: 60%;
            height: 100%;
            background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(255, 255, 255, 0.06) 50%,
                transparent 100%
            );
            animation: shimmerSlide 1.8s infinite ease-in-out;
        }
        @keyframes shimmerSlide {
            0%   { left: -80%; }
            100% { left: 130%; }
        }
        .video-preloader-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            z-index: 1;
        }
        .video-spinner-ring {
            width: 56px;
            height: 56px;
            border: 4px solid rgba(255, 255, 255, 0.15);
            border-top-color: #ffffff;
            border-radius: 50%;
            animation: spinRing 0.9s linear infinite;
        }
        @keyframes spinRing {
            to { transform: rotate(360deg); }
        }
        .video-loading-text {
            color: rgba(255, 255, 255, 0.75);
            font-size: 14px;
            margin: 0;
            letter-spacing: 0.5px;
        }
    `]
})
export class MediaCenterDetailComponent extends AppComponentBase implements OnInit {

    mediaCenter: GetMediaCenterForViewDto;
    loading = false;
    videoLoading = false;
    imageUrl: SafeResourceUrl;
    videoUrl: SafeResourceUrl;

    constructor(
        injector: Injector,
        private _mediaCenterService: MediaCenterServiceProxy,
        private _mediaLibraryService: MediaLibraryServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _sanitizer: DomSanitizer,
        private _http: HttpClient
    ) {
        super(injector);
    }

    ngOnInit(): void {
        const id = this._activatedRoute.snapshot.params['id'];
        if (id) {
            this.getMediaCenter(id);
        }
    }

    getMediaCenter(id: number): void {
        this.loading = true;
        this._mediaCenterService.getPublished(id)
            .subscribe(result => {
                this.mediaCenter = result;
                this.loading = false;
                // Pre-set videoLoading BEFORE calling loadVideo so the
                // preloader appears immediately when a video attachment exists.
                if (result?.mediaCenter?.vidioAttachments) {
                    this.videoLoading = true;
                }
                this.loadImage();
                this.loadVideo();
            }, error => {
                console.error('Failed to load media center item', error);
                this.loading = false;
            });
    }

    loadImage(): void {
        if (this.mediaCenter?.mediaCenter?.imageAttachments) {
            const url = `${AppConsts.remoteServiceBaseUrl}/api/MediaLibrary/GetMediaForAnonymous?fileToken=${this.mediaCenter.mediaCenter.imageAttachments}`;
            this._http.get<any>(url)
                .subscribe(result => {
                    if (result && result.result && result.result.fileContent) {
                        this.imageUrl = this._sanitizer.bypassSecurityTrustResourceUrl(result.result.fileContent);
                    }
                }, error => {
                    console.error('Failed to load image', error);
                });
        }
    }

    loadVideo(): void {
        if (this.mediaCenter?.mediaCenter?.vidioAttachments) {
            const url = `${AppConsts.remoteServiceBaseUrl}/api/MediaLibrary/GetMediaForAnonymous?fileToken=${this.mediaCenter.mediaCenter.vidioAttachments}`;
            this._http.get<any>(url)
                .subscribe(result => {
                    if (result && result.result && result.result.fileContent) {
                        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(result.result.fileContent);
                    }
                    this.videoLoading = false;
                }, error => {
                    console.error('Failed to load video', error);
                    this.videoLoading = false;
                });
        }
    }

    goBack(): void {
        window.history.back();
    }
}
